module.exports = __webpack_public_path__ + "static/media/undraw.3d8bba45.png";